/* global __APP_VERSION__ */
const local_version = __APP_VERSION__;

console.log(`App version is ${local_version}`);

let timer = null;

function startPolling() {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }

  timer = setInterval(async () => {
    const res = await fetch(`./version.json?t=${Date.now()}`, {
      cache: 'no-cache',
      headers: {
        'Cache-Control': 'no-cache'
      }
    });
    if (!res.ok) {
      console.error('Fetch Version Failed.');
      return;
    }

    const data = await res.json();
    const remote_version = data.version;

    if (Number(local_version) !== Number(remote_version)) {
      sessionStorage.setItem('hasNewVersion', 'true');
      clearInterval(timer);
      timer = null;
    }
  }, 60000);
}

// 仅在非开发环境下启动轮询检测
if (local_version !== 'dev') {
  setTimeout(startPolling, 5000);
}


